
import ApiService from '../base/api_service';

export const getTransactionUpdate    = async (accessToken, params) => {
    try {
        const response = await ApiService.get(`/transaction-updates`, {
            params: params,
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const showTransactionUpdate    = async (accessToken, id) => {
    try {
        const response = await ApiService.get(`/transaction-update/show/${id}`, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const postTransactionUpdate = async (accessToken, data) => {
    try {
        const response = await ApiService.post('/transaction-update/create', data, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const updateTransactionUpdate = async (accessToken, id, data) => {
    try {
        const response = await ApiService.post(`/transaction-update/update/${id}`, data, {
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}